import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'

import { clearToast as clearToastAction } from '../store/actions'
import { getToast } from '../store/selectors'

import NotificationMessage from './NotificationMessage'
import ToastClose from './ToastClose'

const ToastContainerWrapper = () => {
  const initialToast = useSelector(getToast)
  const message = initialToast.message
  const type = initialToast.type

  const dispatch = useDispatch()

  useEffect(() => {
    if (!type || !message) {
      return
    }
    // show the toast
    toast(<NotificationMessage message={message} />, { type })
    // clear the state
    dispatch(clearToastAction())
  }, [dispatch, message, type])

  return (
    <ToastContainer
      className='qa-toast'
      theme='colored'
      icon={false}
      autoClose={false}
      position={toast.POSITION.TOP_CENTER}
      hideProgressBar
      closeButton={<ToastClose />}
    />
  )
}

export default ToastContainerWrapper
